export default "__VITE_ASSET__slRDaJB0__"